import { Button } from '@material-ui/core';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { Link as RRLink, useHistory } from 'react-router-dom';
import Pic403 from './../../assets/Error403.png';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'block',
      textAlign: 'center'
    },
    picture: {
      marginTop: theme.spacing(10),
      width: 480,
      [theme.breakpoints.down('xs')]: {
        width: 280
      }
    },
    credit: {
      textDecoration: 'none',
      color: theme.palette.text.secondary,
      fontSize: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.spacing(0.6)
      }
    },
    text: {
      padding: theme.spacing(0, 4)
    },
    button: {
      margin: theme.spacing(1),
      marginTop: 0
    }
  })
);

export default function Error404() {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <img
        className={classes.picture}
        src={Pic403}
        alt={t('error.altError403') as string}
      />
      <div>
        <a className={classes.credit} href="https://www.freepik.com/vectors">
          {t('common.freepikCredit')}
        </a>
      </div>
      <h3 className={classes.text}>{t('error.message403')}</h3>
      <Button
        className={classes.button}
        color="primary"
        size="large"
        onClick={() => {
          history.goBack();
        }}
      >
        {t('error.back')}
      </Button>
      <Button
        className={classes.button}
        to="/"
        component={RRLink}
        variant="contained"
        color="primary"
        size="large"
      >
        {t('error.home')}
      </Button>
    </div>
  );
}
